<template>
  <div class="h-100">
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <CCard accent-color="info" class="h-100" v-if="userInfo && Object.keys(userInfo).length">
          <CCardHeader class="px-3">
            <CRow>
              <CCol col="8">
                <h4 class="text-uppercase mb-0 mt-1">
                  <router-link to="/system/user">
                    <CIcon name="cil-arrow-circle-left" class="mt-0 mb-1 mr-1 x2"></CIcon>
                  </router-link>
                  Tài khoản: <span class="text-crimson" style="text-transform: none !important;">
                    {{ userInfo.name }}
                  </span>
                </h4>
              </CCol>
              <CCol col="4" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="6">
                        <CButton v-if="userInfo.is_verified === 1" block color="dark" @click="onDeactiveUser">
                          Khóa tài khoản
                        </CButton>
                        <CButton v-else block color="success" @click="onActiveUser">Kích hoạt tài khoản</CButton>
                      </CCol>
                      <CCol col="6">
                        <CButton block color="danger" @click="onDeleteUser">Xóa tài khoản</CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody class="p-3 h-100">
            <CRow class="h-100">
              <CCol col="4" class="form-content-static h-100 pr-0">
                <CCard border-color="danger" class="h-100 card-scroll-y">
                  <CCardHeader class="text-center bg-gradient-01 pb-3">
                    <b-avatar v-if="String(userInfo.avatar).trim().length" :src="userInfo.avatar"
                              variant="light" size="10rem" badge-offset="3px"
                              :badge-variant="userInfo.is_verified === 1 ? 'success' : 'dark'"
                              class="mt-5 avatar-user-detail cursor-pointer"
                              v-b-modal="'cc-modal-show-avatar'" title="Chi tiết ảnh đại diện">
                      <template #badge>
                        <b-icon :icon="userInfo.is_verified === 1 ? 'check-circle-fill' : 'x-circle-fill'"></b-icon>
                      </template>
                    </b-avatar>
                    <b-avatar v-else variant="info" text="Dak Land" size="10rem" badge-offset="3px"
                              :badge-variant="userInfo.is_verified === 1 ? 'success' : 'dark'"
                              class="mt-5 avatar-user-detail b-avatar-detail bg-color-animation">
                      <template #badge>
                        <b-icon :icon="userInfo.is_verified === 1 ? 'check-circle-fill' : 'x-circle-fill'"></b-icon>
                      </template>
                    </b-avatar>
                    <cc-modal v-if="String(userInfo.avatar).trim().length" id="cc-modal-show-avatar"
                              title="Chi tiết ảnh đại diện" size="lg" body-class-name="text-center">
                      <template slot="body">
                        <b-avatar :src="userInfo.avatar" size="25rem" square></b-avatar>
                      </template>
                      <template slot="footer">
                        <CButton color="secondary" class="px-3"
                                 @click="closeModal('cc-modal-show-avatar')">
                          Đóng
                        </CButton>
                      </template>
                    </cc-modal>
                    <h3 class="mt-3 text-white">{{ userInfo.full_name }}
                      <span v-for="(item, index) in userTypeList" :key="index" class="c-badge-in-h3">
                        <CBadge v-if="item.id === userInfo.user_type" :class="item.className">
                          {{ item.name }}
                        </CBadge>
                      </span>
                    </h3>
                    <hr class="text-white mb-3" style="height: .3rem;"/>
                    <validation-provider name="Ảnh đại diện" rules="mimes:image/*" v-slot="{valid, errors}">
                      <CRow>
                        <CCol col="6" v-if="isAllowChangeAvatar">
                          <CButton block color="light" @click="openChooseImage">
                            <CIcon v-if="formData.fileAvatar && !errors[0]" name="cil-check" class="text-success"
                                   style="margin: 0; top: -2px; position: relative;"/>
                            <CIcon v-if="errors[0]" name="cil-x-circle" class="text-danger"
                                   style="margin: 0; top: -2px; position: relative;"/>
                            Thay ảnh đại diện
                          </CButton>
                          <b-form-file ref="fileInputAvatar" v-model="formData.fileAvatar"
                                       class="d-none" accept="image/*"
                                       :state="!valid && errors[0] ? valid : null"
                                       aria-describedby="input-image-avatar"
                                       @change="onChangeInputAvatar"></b-form-file>
                        </CCol>
                        <CCol :col="isAllowChangeAvatar ? 6 : {size: 6, offset: 3}">
                          <CButton block color="success" @click="moveListByUser">Xem tin quy hoạch</CButton>
                        </CCol>
                      </CRow>
                      <CRow v-if="formData.fileAvatar && isAllowChangeAvatar && errors[0]" class="mt-1">
                        <CCol col="12">
                          <b-form-invalid-feedback id="input-image-avatar" class="py-1 bg-light d-block">
                            {{ errors[0] }}
                          </b-form-invalid-feedback>
                        </CCol>
                      </CRow>
                    </validation-provider>
                  </CCardHeader>
                  <CCardBody class="p-2">
                    <CListGroup class="item-only-border-bottom">
                      <CListGroupItem>
                        Giới tính:
                        <template v-if="String(userInfo.user_sex).trim().length">
                          <span v-for="(item, index) in userSexList" :key="index">
                            <template v-if="item.id === userInfo.user_sex">
                              <CIcon :name="item.classIcon" :class="item.className" :key="item.id"
                                     style="position: relative; top: -3px;"/>
                              {{ item.name }}
                            </template>
                          </span>
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CListGroupItem>
                        Điện thoại:
                        <template v-if="String(userInfo.phone).trim().length">
                          <CIcon name="cil-phone" class="text-danger"/>
                          {{ userInfo.phone }}
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CListGroupItem>
                        Email:
                        <template v-if="String(userInfo.email).trim().length">
                          <CIcon name="cil-envelope-letter" class="text-success"/>
                          {{ userInfo.email }}
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CListGroupItem>
                        Cấp Tỉnh:
                        <template v-if="String(userInfo.province_name).trim().length">
                          {{ userInfo.province_name }}
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CListGroupItem>
                        Cấp Huyện:
                        <template v-if="String(userInfo.district_name).trim().length">
                          {{ userInfo.district_name }}
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CListGroupItem>
                        Cấp Xã:
                        <template v-if="String(userInfo.commune_name).trim().length">
                          {{ userInfo.commune_name }}
                        </template>
                        <span v-else>---</span>
                      </CListGroupItem>
                      <CRow>
                        <CCol>
                          <CListGroupItem>
                            Coin: <strong>{{ fNumber(Number(userInfo.coin || 0)) }}</strong>
                          </CListGroupItem>
                        </CCol>
                        <CCol>
                          <CListGroupItem>
                            Dakland: <strong>{{ fNumber(Number(userInfo.dakland || 0)) }}</strong>
                          </CListGroupItem>
                        </CCol>
                      </CRow>
                    </CListGroup>
                  </CCardBody>
                </CCard>
              </CCol>
              <CCol col="1" class="text-center align-self-center px-0">
                <CIcon name="cil-caret-right" height="64" class="text-primary"/>
              </CCol>
              <CCol col="7" class="form-content-dynamic h-100 pl-0">
                <CCard border-color="success" class="h-100 card-scroll-y">
                  <CCardBody>
                    <validation-observer tag="form" ref="form">
                      <CRow class="mb-3">
                        <CCol col="6">
                          <validation-provider name="Họ tên" rules="required" v-slot="{valid, errors}">
                            <label for="input-full-name">
                              Họ tên
                              <span class="text-star-validate-01">*</span>
                            </label>
                            <b-form-input id="input-full-name" v-model="formData.full_name" placeholder="Nhập họ tên..."
                                          trim aria-describedby="input-fFullName"
                                          :state="!valid && errors[0] ? valid : null">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-fFullName">{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </CCol>
                        <CCol col="6">
                          <validation-provider name="Email" rules="required|email" v-slot="{valid, errors}">
                            <label for="input-email">
                              Email
                              <span class="text-star-validate-01">*</span>
                            </label>
                            <b-form-input id="input-email" v-model="formData.email" placeholder="Nhập email..."
                                          trim aria-describedby="input-fEmail"
                                          :state="!valid && errors[0] ? valid : null">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-fEmail">{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol col="6">
                          <validation-provider name="Số điện thoại"
                                               :rules="{regex: /^[+0-9]+$/, required: { allowFalse: false }, max: 12}"
                                               v-slot="{valid, errors}">
                            <label for="input-phone">
                              Điện thoại
                              <span class="text-star-validate-01">*</span>
                            </label>
                            <b-form-input id="input-phone" v-model="formData.phone" placeholder="Nhập số điện thoại..."
                                          trim aria-describedby="input-fPhone"
                                          :state="!valid && errors[0] ? valid : null">
                            </b-form-input>
                            <b-form-invalid-feedback id="input-fPhone">{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </CCol>
                      </CRow>
                      <hr/>
                      <CRow>
                        <CCol col="6">
                          <validation-provider name="Giới tính" rules="required" v-slot="{valid, errors}">
                            <label>
                              Giới tính
                              <span class="text-star-validate-01">*</span>
                            </label>
                            <b-form-select v-model="formData.user_sex" :options="userSexList" value-field="id"
                                           text-field="name" class="text-dark"
                                           :state="!valid && errors[0] ? valid : null"
                                           aria-describedby="input-fUserSex">
                            </b-form-select>
                            <b-form-invalid-feedback id="input-fUserSex">{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </CCol>
                        <CCol col="6">
                          <validation-provider name="Phân loại" rules="required" v-slot="{valid, errors}">
                            <label>
                              Phân loại
                              <span class="text-star-validate-01">*</span>
                            </label>
                            <b-form-select v-model="formData.user_type" :options="userTypeList" value-field="id"
                                           text-field="name" class="text-dark"
                                           :state="!valid && errors[0] ? valid : null"
                                           aria-describedby="input-fUserType">
                            </b-form-select>
                            <b-form-invalid-feedback id="input-fUserType">{{ errors[0] }}</b-form-invalid-feedback>
                          </validation-provider>
                        </CCol>
                      </CRow>
                      <hr/>
                      <template v-for="(item, index) in dataSelectInit">
                        <CRow :key="index" class="mb-3">
                          <CCol col="2">
                            <label class="mb-0 mt-1">{{ item.itemName }}</label>
                          </CCol>
                          <CCol col="10">
                            <model-list-select class="select-with-search" option-value="id" option-text="name"
                                               :list="item.key === 'provinces' ? provinceList : (item.key === 'districts' ? districtList : communeList)"
                                               v-model="formData[item.modelExt]"
                                               @input="modelListSltChange($event, item.key)">
                            </model-list-select>
                          </CCol>
                        </CRow>
                      </template>
                    </validation-observer>
                  </CCardBody>
                  <CCardFooter v-if="isAllowChangeAvatar">
                    <CRow>
                      <CCol :col="{ size: 3, offset: 9 }" class="float-right">
                        <CButton block class="status-pending text-dark" v-b-modal="'cc-modal-center'">Thay đổi mật
                          khẩu
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCardFooter>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="px-3">
            <CRow>
              <CCol :col="{ size: 4, offset: 8 }" class="float-right">
                <CRow>
                  <CCol :col="{ size: 4, offset: 8 }">
                    <CButton block color="info" :disabled="isDisableBtnUpdate"
                             @click="updateUserInfo">
                      Cập nhật
                    </CButton>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <cc-modal title="Đổi mật khẩu" size="lg" @onShowModal="onShowModal">
      <template slot="body" v-if="userInfo && Object.keys(userInfo).length">
        <p class="text-muted">
          Thay đổi mật khẩu mới cho tài khoản: <b class="text-danger">{{ userInfo.name }}</b>
        </p>
        <validation-observer tag="form" ref="formChangePassword" onsubmit="return false">
          <CRow class="px-5">
            <CCol col="12">
              <CRow class="mb-3">
                <CCol col="4">
                  <label class="mb-0 mt-1">
                    Mật khẩu mới
                    <span class="text-star-validate-01">*</span>
                  </label>
                </CCol>
                <CCol col="8">
                  <validation-provider name="Mật khẩu" rules="required|alpha_dash|min:8" vid="password"
                                       v-slot="{valid, errors}">
                    <b-form-input v-model="modalData.password" placeholder="Mật khẩu mới"
                                  :state="!valid && errors[0] ? valid : null"
                                  type="password" autocomplete="curent-password"
                                  aria-describedby="input-password"
                                  @keydown.enter.prevent="onChangePassword">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-password">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="mb-1">
                <CCol col="4">
                  <label class="mb-0 mt-1">
                    Nhập lại mật khẩu mới
                    <span class="text-star-validate-01">*</span>
                  </label>
                </CCol>
                <CCol col="8">
                  <validation-provider name="Xác nhận mật khẩu" rules="required|alpha_dash|min:8|confirmed:password"
                                       v-slot="{valid, errors}">
                    <b-form-input v-model="modalData.passwordConfirm" placeholder="Nhập lại mật khẩu mới"
                                  :state="!valid && errors[0] ? valid : null"
                                  type="password" autocomplete="curent-password"
                                  aria-describedby="input-password-confirm"
                                  @keydown.enter.prevent="onChangePassword">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-password-confirm">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </validation-observer>
      </template>
      <template slot="footer">
        <div class="w-100 text-right">
          <CButton color="success" class="px-3 mr-2"
                   :disabled="!(modalData.password && modalData.passwordConfirm)"
                   @click="onChangePassword">
            Thực hiện
          </CButton>
          <CButton color="secondary" class="px-3" @click="closeModal('cc-modal-center')">Đóng</CButton>
        </div>
      </template>
    </cc-modal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {COMMON, USER_SEX, USER_TYPE, FORM_DATA_UPDATE_USER} from '@/common/Constant'
import {format} from '@/mixins/format'
import * as _ from 'lodash'
import {convertInputFileToBase64, SHOW_TOAST_2} from '@/common/lib'
import {ModelListSelect} from 'vue-search-select'
import CcModal from '@/components/common/CcModal'
import {firebaseStorage} from '@/mixins/firebaseStorage'

export default {
  name: "CreateOrUpdate",
  mixins: [
    format,
    firebaseStorage
  ],
  components: {
    ModelListSelect,
    CcModal
  },
  data() {
    return {
      isDisableBtnUpdate: false,
      isAllowChangeAvatar: false,
      userSexList: USER_SEX,
      userTypeList: USER_TYPE,
      userInfo: null,
      formData: {
        avatar: '',
        fileAvatar: null,
        full_name: '',
        email: '',
        phone: '',
        user_sex: null,
        user_type: null,
        province_id: -1,
        district_id: -1,
        commune_id: -1
      },
      selectOptionNull: {
        id: -1,
        name: '-- Chọn giá trị --'
      },
      provinceList: [],
      districtList: [],
      communeList: [],
      dataSelectInit: _.concat([], COMMON.dataSelectInitZoningCreateOrUpdate),
      modalData: {
        password: '',
        passwordConfirm: ''
      },
      avatarImageUploader: {}
    }
  },
  async created() {
    if (this.$route && this.$route.params) {
      this.userInfo = _.merge({}, this.$route.params.userInfo)
      this.dataSelectInit.splice(3, 2)
      await Promise.all([
        this.provinceList.push(this.selectOptionNull),
        this.districtList.push(this.selectOptionNull),
        this.communeList.push(this.selectOptionNull)
      ])
      if (this.$route.name === 'My Profile' && (this.userInfo && this.userInfo.id === this.$cookies.get('userInfo')['userId'])) {
        this.isAllowChangeAvatar = true
      }
      if (!this.userInfo || !Object.keys(this.userInfo).length) {
        await this.$router.push({name: 'User List'})
      } else {
        document.title = `Thông tin tài khoản: ${this.userInfo.name}`
        await _.merge(this.formData, this.userInfo)
      }
    } else {
      await this.$router.push({name: 'User List'})
    }
  },
  async mounted() {
    await this.getLocationAndZoneTypeList()
    this.initDataList()
  },
  methods: {
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    ...mapActions('auth', ['userLogout', 'onChangePw']),
    ...mapActions('user', ['getUserDetail', 'updateOnCellTable', 'deleteSelectedList']),
    async moveListByUser() {
      if (this.$cookies.isKey('userInfo')) {
        let _name = 'Zoning by User'
        if (this.userInfo.id === this.$cookies.get('userInfo')['userId']) {
          _name = 'Zoning by Me'
        }
        await this.$router.push({
          name: _name,
          params: {
            userId: this.userInfo.id,
            fullName: this.userInfo.full_name
          }
        })
      } else {
        await this.$router.push({
          name: 'Login',
          params: {
            pathName: window.location.pathname
          },
          query: {
            isExpired: true
          }
        })
      }
    },
    initDataList() {
      if (this.formData.province_id === 0) this.formData.province_id = -1
      if (this.formData.district_id === 0) this.formData.district_id = -1
      if (this.formData.commune_id === 0) this.formData.commune_id = -1
      this.provinceList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('provinceList')))
      if (this.formData.province_id !== -1) {
        this.districtList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('districtList')).filter(item => item['province_id'] === this.formData.province_id))
      }
      if (this.formData.district_id !== -1) {
        this.communeList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('communeList')).filter(item => item['district_id'] === this.formData.district_id))
      }
    },
    openChooseImage() {
      this.$refs.fileInputAvatar.$el.childNodes[0].click()
    },
    async onChangeInputAvatar(e) {
      const file = e.target.files[0]
      const imageBase64 = await convertInputFileToBase64(file)
      if (imageBase64) {
        if (imageBase64.split('/')[0] === 'data:image') {
          this.isDisableBtnUpdate = false
          this.userInfo.avatar = imageBase64
          this.avatarImageUploader = this.createUploader(file)
        } else {
          this.isDisableBtnUpdate = true
          this.userInfo.avatar = this.formData.avatar
          this.avatarImageUploader = {}
        }
      } else {
        this.isDisableBtnUpdate = false
        this.userInfo.avatar = this.formData.avatar
        this.avatarImageUploader = {}
      }
    },
    setAgainParamUserInfo(_key, _value) {
      this.userInfo[_key] = _value
      _.merge(this.formData, this.userInfo)
    },
    async onDeactiveUser() {
      const confirm = window.confirm(`Bạn có chắc chắn muốn khóa tài khoản: "${this.userInfo.name}"?`)
      if (confirm) {
        const _param = {
          updated_user_id: this.userInfo.id,
          is_verified: 2
        }
        const res = await this.updateOnCellTable(_param)
        await this.showToastUpdateOrDeleteOnList(res, 'is_verified', 2, 2)
      }
    },
    async onActiveUser() {
      const _param = {
        updated_user_id: this.userInfo.id,
        is_verified: 1
      }
      const res = await this.updateOnCellTable(_param)
      await this.showToastUpdateOrDeleteOnList(res, 'is_verified', 1, 1)
    },
    async onDeleteUser() {
      const confirm = window.confirm(`Bạn có chắc chắn muốn xóa user: "${this.userInfo.name}"?`)
      if (confirm) {
        const res = await this.deleteSelectedList([this.userInfo.id])
        await this.showToastUpdateOrDeleteOnList(res)
      }
    },
    async updateUserInfo() {
      if (!this.isDisableBtnUpdate) {
        const valid = await this.$refs.form.validate()
        if (valid) {
          try {
            if (this.formData.fileAvatar && this.avatarImageUploader && Object.keys(this.avatarImageUploader).length > 0) {
              await this.uploadToFirebaseStorage(this.avatarImageUploader)
            }

            const _formData = {
              updated_user_id: this.userInfo.id
            }
            FORM_DATA_UPDATE_USER.map(item => {
              _formData[item] = this.formData[item]
              return item
            })

            if (this.avatarImageUploader && Object.keys(this.avatarImageUploader).length > 0) {
              _formData['avatar'] = this.avatarImageUploader.url
            }

            if (_formData.commune_id === -1) _formData.commune_id = 0
            if (_formData.district_id === -1) _formData.district_id = 0
            if (_formData.province_id === -1) _formData.province_id = 0
            if (_formData.user_sex === 0) _formData.user_sex = 1
            if (_formData.user_type === 0) _formData.user_type = 1

            const res = await this.updateOnCellTable(_formData)
            if (res && res === 'updateOnCellTableSuccess') {
              SHOW_TOAST_2('success', 'Cập nhật thông tin user thành công.')
              if (this.userInfo.id === this.$cookies.get('userInfo')['userId']) {
                if (this.formData.user_type !== 3) {
                  await this.logoutWhenUpdateOrDelete()
                  return
                } else {
                  await this.getUserDetail()
                  await this.$router.push({name: 'User List'})
                }
              } else {
                await this.getUserDetail()
                await this.$router.push({name: 'User List'})
              }
            } else {
              SHOW_TOAST_2('error', 'Thực hiện thất bại.')
            }
          } catch (e) {
            SHOW_TOAST_2('error', 'Quá trình cập nhật thất bại.')
            throw e
          }
        }
      } else {
        SHOW_TOAST_2('error', 'Không thể thực hiện yêu cầu này. Vui lòng thử lại!')
      }
    },
    async showToastUpdateOrDeleteOnList(_res, _keyChange, _valueChange, _typeToast) {
      if (_res) {
        if (_res === 'updateOnCellTableSuccess') {
          if (_typeToast === 999) {
            SHOW_TOAST_2('success', 'Cập nhật thông tin user thành công.')
          } else if (_typeToast === 1) {
            SHOW_TOAST_2('success', 'Kích hoạt user thành công.')
          } else if (_typeToast === 2) {
            SHOW_TOAST_2('success', 'Khóa user thành công.')
          }
          if (this.userInfo.id === this.$cookies.get('userInfo')['userId']) {
            if ((_keyChange === 'user_type' && _valueChange !== 3) || (_keyChange === 'is_verified' && _valueChange === 2)) {
              await this.logoutWhenUpdateOrDelete()
              return
            }
          } else {
            this.setAgainParamUserInfo(_keyChange, _valueChange)
          }
        } else if (_res === 'deleteSelectedTableSuccess') {
          SHOW_TOAST_2('success', 'Xóa user thành công.')
          if (this.userInfo.id === this.$cookies.get('userInfo')['userId']) {
            await this.logoutWhenUpdateOrDelete()
            return
          } else {
            await this.$router.push({name: 'User List'})
          }
        } else {
          SHOW_TOAST_2('error', 'Không thể thực hiện. Vui lòng kiểm tra lại!')
        }
      } else {
        SHOW_TOAST_2('error', 'Thực hiện thất bại.')
      }
    },
    async logoutWhenUpdateOrDelete() {
      const res = await this.userLogout()
      if (res) {
        this.$cookies.remove('userInfo')
        await this.$router.push({
          name: 'Login',
          params: {
            pathName: window.location.pathname
          },
          query: {
            isExpired: true
          }
        })
      }
    },
    modelListSltChange(_value, type) {
      if (_value) {
        if (_value !== -1) {
          if (type === 'provinces') {
            this.districtList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('districtList')).filter(item => item['province_id'] === _value))
          } else if (type === 'districts') {
            this.communeList = _.concat([this.selectOptionNull], JSON.parse(localStorage.getItem('communeList')).filter(item => item['district_id'] === _value))
          }
        } else {
          if (type === 'provinces') {
            this.districtList = [this.selectOptionNull]
            this.communeList = [this.selectOptionNull]
            this.formData.district_id = -1
            this.formData.commune_id = -1
          } else if (type === 'districts') {
            this.communeList = [this.selectOptionNull]
            this.formData.commune_id = -1
          }
        }
      }
    },
    onShowModal() {
      this.modalData.password = ''
      this.modalData.passwordConfirm = ''
    },
    async onChangePassword() {
      const valid = await this.$refs.formChangePassword.validate()
      if (valid) {
        const data = {
          _param: {
            id: this.userInfo.id,
            password: this.modalData.passwordConfirm
          }
        }
        const res = await this.onChangePw(data)
        if (res) {
          SHOW_TOAST_2('success', 'Thay đổi mật khẩu thành công.')
          if (this.userInfo.id === this.$cookies.get('userInfo')['userId']) {
            await this.logoutWhenUpdateOrDelete()
          }
        } else {
          SHOW_TOAST_2('error', 'Không thể thực hiện thay đổi mật khẩu. Vui lòng thử lại!')
        }
      }
    },
    closeModal(id) {
      this.$bvModal.hide(id)
    }
  }
}
</script>

<style scoped>
.b-avatar {
  border: 5px solid #ebedef;
}

.b-avatar-badge {
  font-size: calc(1rem) !important;
}

.c-badge-in-h3 >>> .badge {
  font-size: .8rem;
  border: 1px solid white;
  position: relative;
  top: -4px;
  margin-left: 5px;
}
</style>
